import React, { ReactNode } from 'react'
import Text from '@embracesbs/component-text'

interface SectionCardProps {
  title?: string
  children: ReactNode
}

// Groups a block of form fields into a subtle, consistent "section" card.
// Styled via the tma-section-card classes in index.css so the calm-mode rules
// (.calm-form) can restyle it on the tenant Deploytime form.
const SectionCard: React.FC<SectionCardProps> = ({ title, children }) => {
  return (
    <div className='tma-section-card'>
      {title && <Text textStyle='h6' content={title} />}
      <div className={title ? 'tma-section-card-body' : undefined}>{children}</div>
    </div>
  )
}

export default SectionCard
